import { inject } from '@angular/core'

import { Actions, createEffect, ofType } from '@ngrx/effects'

import { map } from 'rxjs'

import { ApplicationResourceType } from '@flowx/designer/shared/entities/application.entity'

import { createDataModelEffects } from './data-model.effects'

import { DataModelApiService } from '../../api/data-model.api'
import { CustomComponentDataModelEntityToUIEntity } from '../../entities/data-model.entity'
import { CustomComponentDataModelActions } from '../actions/custom-component-data-model.actions'

const customComponentDataModelBasicEffects = createDataModelEffects(
  ApplicationResourceType.CustomComponent,
  {
    load: CustomComponentDataModelActions.loadEntities,
    loadSuccess: CustomComponentDataModelActions.loadEntitiesSuccess,
    loadFailure: CustomComponentDataModelActions.loadEntitiesFailure,
    add: CustomComponentDataModelActions.addEntity,
    addSuccess: CustomComponentDataModelActions.addEntitySuccess,
    addFailure: CustomComponentDataModelActions.addEntityFailure,
    edit: CustomComponentDataModelActions.editEntity,
    editSuccess: CustomComponentDataModelActions.editEntitySuccess,
    editFailure: CustomComponentDataModelActions.editEntityFailure,
    addAttribute: CustomComponentDataModelActions.addAttribute,
    addAttributeSuccess: CustomComponentDataModelActions.addAttributeSuccess,
    addAttributeFailure: CustomComponentDataModelActions.addAttributeFailure,
    editAttribute: CustomComponentDataModelActions.editAttribute,
    editAttributeSuccess: CustomComponentDataModelActions.editAttributeSuccess,
    editAttributeFailure: CustomComponentDataModelActions.editAttributeFailure,
    requestDeleteEntity: CustomComponentDataModelActions.deleteEntityRequested,
    deleteEntity: CustomComponentDataModelActions.deleteEntity,
    deleteEntitySuccess: CustomComponentDataModelActions.deleteEntitySuccess,
    deleteEntityFailure: CustomComponentDataModelActions.deleteEntityFailure,
    requestDeleteAttribute: CustomComponentDataModelActions.deleteAttributeRequested,
    deleteAttribute: CustomComponentDataModelActions.deleteAttribute,
    deleteAttributeSuccess: CustomComponentDataModelActions.deleteAttributeSuccess,
    deleteAttributeFailure: CustomComponentDataModelActions.deleteAttributeFailure,
    resetErrors: CustomComponentDataModelActions.resetErrors,
    resetErrorsSuccess: CustomComponentDataModelActions.resetErrorsSuccess,
    updateAttributeValidators: CustomComponentDataModelActions.updateAttributeValidators,
    updateAttributeValidatorsSuccess:
      CustomComponentDataModelActions.updateAttributeValidatorsSuccess,
    updateAttributeValidatorsFailure:
      CustomComponentDataModelActions.updateAttributeValidatorsFailure,
  },
  DataModelApiService
)

export const customComponentLoadEntities$ = customComponentDataModelBasicEffects.loadEntities$
export const customComponentAddEntity$ = customComponentDataModelBasicEffects.addEntity$
export const customComponentEditEntity$ = customComponentDataModelBasicEffects.editEntity$
export const customComponentAddAttribute$ = customComponentDataModelBasicEffects.addAttribute$
export const customComponentEditAttribute$ = customComponentDataModelBasicEffects.editAttribute$
export const customComponentSetNewEntityAsAttribute$ =
  customComponentDataModelBasicEffects.setNewEntityAsAttribute$
export const customComponentStartDeleteEntity$ =
  customComponentDataModelBasicEffects.startDeleteEntity$
export const customComponentDeleteEntity$ = customComponentDataModelBasicEffects.deleteEntity$
export const customComponentStartDeleteAttribute$ =
  customComponentDataModelBasicEffects.startDeleteAttribute$
export const customComponentDeleteAttribute$ = customComponentDataModelBasicEffects.deleteAttribute$
export const customComponentResetErrors$ = customComponentDataModelBasicEffects.resetErrors$
export const customComponentUpdateAttributeValidators$ =
  customComponentDataModelBasicEffects.updateAttributeValidators$

export const updateDataModelFromParamsUpdate$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(CustomComponentDataModelActions.updateEntitiesFromParamsUpdate),
      map(({ resourceId, entities }) =>
        CustomComponentDataModelActions.loadEntitiesSuccess({
          resourceId,
          entities: entities.map((e) => CustomComponentDataModelEntityToUIEntity(e)),
        })
      )
    ),
  { functional: true }
)
